// env.js
export const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  appUrl: process.env.REACT_APP_APP_URL || 'http://localhost:3001',
  nodeEnv: process.env.REACT_APP_APP_ENV || 'development',
  SenseInsightPublicUrl: process.env.REACT_APP_SENSE_INSIGHT_URL || 'http://localhost:3000',
};
